module.exports = __webpack_public_path__ + "static/RajKapoorSingh-79386163875f55e435ecc19e81e744fc.jpg";